<template>
    <div class="form-item-image-input">
        <div class="d-flex flex-row mt-3"
             :class="optionsLocation"
             v-if="question.imageType === 'Icon'">
            <div class="px-2 text-center"
                 v-for="(item, index) in question.options"
                 :key="index">
                <input v-if="type == 'radio'" class="btn-check btn-check-icon" autocomplete="off"
                       :id="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :name="name"
                       :type="type"
                       @input="onInput"
                       :value="[item.other == 1 ? 'other' :item.optionId]"
                       v-model="checkedItems">
                <input v-if="type == 'checkbox'" class="btn-check btn-check-icon" autocomplete="off"
                       :id="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :name="name"
                       :type="type"
                       @change="onInput"
                       :value="[item.other == 1 ? 'other' :item.optionId]"
                       v-model="checkedItems">
                <label class="btn btn-radio element-image-item"
                       @click="clickImage($event, 'form-global-' + typeFieldId + '_' + fieldId + '_' + index, item.other == 1 ? 'other' : item.optionId)"
                       :for="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :class="[item.other == 1 ? 'btn-other' : '']">
                    <img :src='urlImage + item.fileInternal' class="img-fluid" alt="V2M"
                         v-if="item.other != 1">
                    <span v-if="item.other == 1">{{ item.description }}</span>
                </label>
                <p class="image-label my-2"
                   v-if="question.showLabelImage && item.other != 1">{{ item.description }}</p>
            </div>
        </div>
        <div class="d-flex flex-row flex-wrap mt-3"
             :class="optionsLocation"
             v-if="question.imageType === 'Image' || question.imageType === ''">
            <div class="px-2 content-image-btn text-center"
                 v-for="(item, index) in question.options"
                 :key="index">
                <input v-if="type == 'radio'" class="btn-check btn-check-icon" autocomplete="off"
                       :id="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :name="name"
                       :type="type"
                       @input="onInput"
                       :value="[item.other == 1 ? 'other' : item.optionId]"
                       v-model="checkedItems">
                <input v-if="type == 'checkbox'" class="btn-check btn-check-icon" autocomplete="off"
                       :id="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :name="name"
                       :type="type"
                       @change="onInput"
                       :value="[item.other == 1 ? 'other' : item.optionId]"
                       v-model="checkedItems">
                <label class="btn btn-radio-image element-image-item"
                       @click="clickImage($event, 'form-global-' + typeFieldId + '_' + fieldId + '_' + index, item.other == 1 ? 'other' : item.optionId)"
                       :for="'form-global-' + typeFieldId + '_' + fieldId + '_' + index"
                       :class="[item.other == 1 ? 'btn-other' : '']">
                    <img :src='urlImage + item.fileInternal' class="img-fluid" alt="V2M"
                         v-if="item.other != 1">
                    <span v-if="item.other == 1">{{ item.description }}</span>
                </label>
                <p class="image-label my-2"
                   v-if="question.showLabelImage && item.other != 1">{{ item.description }}</p>
            </div>
        </div>
        <text-input v-if="validCheckedItems"
            :field-id="question.questionId"
            :input-class="'form-control question-input-text-other'"
            :label="otherText"
            :label-class="'bold text-color-questions'"
            :model-answer="modelOtherValue"
            :name="'question_' + typeFieldId + '_' + question.questionId + '_' + otherId + '_text_other'"
            :placeholder="true"
            :type="'text'"
            v-on:update:modelAnswer="modelOtherValue = $event" />
        <p v-if="errorMessage" class="has-error-msg">{{ errorMessage }}</p>
    </div>
</template>
<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import { useField } from 'vee-validate';
import TextInput from "./text-input.vue";

// INITIALIZE STORE & COMPOSABLES

// PROPS & EMITS
const props = defineProps({
    errorText: {
        type: String,
        required: false,
    },
    fieldId: {
        type: Number,
        required: true,
    },
    inputClass: {
        type: String,
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    otherText: {
        type: String,
        required: false,
    },
    question: {
        type: Object,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
    typeFieldId: {
        type: Number,
        required: true,
    },
    urlImage: {
        type: String,
        required: false,
    },
    validation: {
        type: Object,
        required: false,
    },
});

const emit = defineEmits(['input', 'invalidInput', 'validInput', 'message']);

// REACTIVE VARIABLES
const checkedItems = ref([]);
const modelOtherValue = ref('');
const otherId = ref(0);

// COMPUTED PROPERTIES
const optionsLocation = computed(() => {
    if (props.question.optionLocation == 'bellowCenter') {
        return 'justify-content-center';
    }
    return '';
});

const validCheckedItems = computed(() => {
    if (props.type == 'radio') {
        return checkedItems.value.includes('other');
    } else {
        return in_array(checkedItems.value, 'other');
    }
});

// METHODS
const in_array = (array, id) => {
    return array.some(function(item) {
        return item[0] === id;
    });
};

const clickImage = (event, idInput, idOption) => {
    event.preventDefault();
    event.stopPropagation();
    console.log('idInput', idInput)
    console.log(document.querySelector('input[id="' + idInput +'"]'))
    if (document.querySelector('input[id="' + idInput +'"]').checked == false) {
        document.querySelector('input[id="' + idInput +'"]').checked = true;
        if (props.type == 'radio') {
            checkedItems.value = [];
            checkedItems.value.push(idOption);
        } else {
            checkedItems.value.push([idOption]);
        }
    } else {
        document.querySelector('input[id="' + idInput +'"]').checked = false;
        if (props.type !== 'radio') {
            checkedItems.value = checkedItems.value.filter(function(item) {
                return item[0] !== idOption;
            });
        } else {
            checkedItems.value = [];
        }
    }
};

const onInput = async (event) => {
    value.value = event.target.value;

    // Emit the new value to parent component
    emit('input', event.target.value);

    // Validate after value update
    await nextTick();
    const result = await validate();
};

// VeeValidate field
const { value, errorMessage, validate } = useField(props.name, props.validation);

// LIFECYCLE HOOKS
onMounted(() => {
    props.question.options.forEach(function (element) {
        if (element.other === true) {
            otherId.value = element.optionId;
        }
    });
});
</script>
